import {createSlice} from '@reduxjs/toolkit';

export const bannerHandler = createSlice({
    name: 'bHandler',
    initialState: {
        visibility:  0,
        message: 'Notificaiton Message here',
        classType: 'error'
    },
    reducers: {

        display: (state, action) => {
          state.visibility === 0 ? state.visibility += 1 : null,
             state.message = action.payload.message,
             state.classType = action.payload.classType
          },
          close: (state) => {
            state.visibility > 0 ? state.visibility -= 1 : null
            // console.log("closed with visibility of: "+state.visibility)
          },
        //   incrementByAmount: (state, action) => {
        //     state.value += action.payload
        //   },
    },
})

// Action creators are generated for each case reducer function
// export const { increment, decrement, incrementByAmount } = apiPath.actions

export const { close, display } = bannerHandler.actions
export default bannerHandler.reducer